import React from "react";
import { useSelector } from "react-redux";
import { getIsExportingGrid } from "@icarius-app/selectors";
import CommonPage from "@icarius-common/commonPage";
import paths from "@icarius-router/paths";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import SetParamDialog from "@icarius-common/setParamDialog";
import useSpecialProcessExecution from "./hooks/useSpecialProcessExecution";
import ListIcon from "@material-ui/icons/List";
import useSpecialProcessQuery from "./hooks/useSpecialProcessQuery";
import { getLocalizedString } from "@icarius-localization/strings";

const SpecialProcessExecution = () => {
    const isExportinGrid = useSelector(getIsExportingGrid);

    const { specialProcessExecutionData, specialProcessExecutionFunctions } = useSpecialProcessExecution();

    const { specialProcessQueryData, specialProcessQueryFunctions } = useSpecialProcessQuery();

    const generateThirdPartyFileItem = (gridRef) => (
        <CustomIconButton
            title={getLocalizedString("execute")}
            onClick={() => specialProcessExecutionFunctions.handleValidateAndAskThirdPartyGenerationProcess(gridRef)}
            type={"execute"}
        />
    );

    const queryButton = (gridRef) => (
        <CustomIconButton
            title={getLocalizedString("specialProcessQuery")}
            onClick={() => specialProcessQueryFunctions.handleGetSpecialProcessQuery(gridRef)}
        >
            <ListIcon />
        </CustomIconButton>
    );

    return (
        <CommonPage
            columnDefPage={paths.specialProcessExecution}
            title={getLocalizedString("specialProcessExecution")}
            gridTitle={getLocalizedString("specialProcessExecution")}
            menuItems={[generateThirdPartyFileItem, queryButton]}
            rowData={specialProcessExecutionData.data}
            dateFormat={specialProcessExecutionData.dateFormat}
            isLoading={isExportinGrid || specialProcessExecutionData.isLoading || specialProcessQueryData.isLoading}
            hasExpand
            hasHelp
        >
            {specialProcessExecutionData.paramDialogIsOpen && (
                <SetParamDialog
                    open={specialProcessExecutionData.paramDialogIsOpen}
                    params={specialProcessExecutionData.paramsToUse}
                    handleClose={specialProcessExecutionFunctions.handleCloseParamDialog}
                    handleAgree={specialProcessExecutionFunctions.generateThirdPartyFile}
                />
            )}
        </CommonPage>
    );
};

export default SpecialProcessExecution;
